import React from "react";
import SearchSelect from "../../generics/SearchSelect";

const PurchaseOrderInputBox = ({
  editingItem,
  selectedItem,
  itemName,
  onItemChange,
  quantity,
  onQuantityChange,
  presentation,
  selectedOffer,
  itemOffers,
  onOfferChange,
  brand,
  brands,
  onBrandChange,
  hasGrade,
  grade,
  grades,
  onGradeChange,
  numberItems,
  onNumberItemsChange,
  price,
  addItem,
  updateItem,
  cancelEditItem,
  isLoadingItems,
  searchItems,
  errors,
}) => {
  var inputStyle = { zIndex: 0 };
  return (
    <div>
      <h5>{editingItem ? "Edit Item" : "Add item"}</h5>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-block">
              <form className="row">
                {editingItem ? (
                  <div className="col-sm-6 form-group row">
                    <label className="col-sm-4 col-form-label" htmlFor="text-input">
                      Item
                    </label>
                    <div className="col-sm-8">
                      <input disabled type="text" id="text-input" name="text-input" className="form-control" value={itemName} />
                    </div>
                  </div>
                ) : (
                  <SearchSelect
                    onChange={onItemChange}
                    getOptions={searchItems}
                    isLoading={isLoadingItems}
                    value={selectedItem}
                    error={errors.indexOf("item") !== -1}
                    class={errors.indexOf("item") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}
                    classLabel="col-sm-4 col-form-label"
                    classInput="col-sm-8"
                    label="Item"
                  />
                )}

                <div className={errors.indexOf("quantity") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">
                    Quantity
                  </label>
                  <div className="col-sm-6 col-10">
                    <input
                      type="number"
                      id="text-input"
                      name="text-input"
                      className={errors.indexOf("quantity") !== -1 ? "form-control form-control-danger" : "form-control"}
                      placeholder="Enter quantity"
                      value={quantity}
                      onChange={(item) => onQuantityChange(item)}
                    />
                  </div>
                  <div className="d-flex align-items-center">{presentation ? presentation : "Case"}</div>
                  {errors.indexOf("quantity") !== -1 ? (
                    <em id="firstname-error" className="error form-control-feedback">
                      Please enter a positive integer value.
                    </em>
                  ) : (
                    <em></em>
                  )}
                </div>

                <div className={errors.indexOf("numberItems") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">
                    Pieces
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="number"
                      id="text-input"
                      name="text-input"
                      className={errors.indexOf("numberItems") !== -1 ? "form-control form-control-danger" : "form-control"}
                      placeholder="Enter number of items"
                      value={numberItems}
                      onChange={(item) => onNumberItemsChange(item)}
                    />
                  </div>
                  {errors.indexOf("numberItems") !== -1 ? (
                    <em id="firstname-error" className="error form-control-feedback">
                      Please enter a positive integer value.
                    </em>
                  ) : (
                    <em></em>
                  )}
                </div>

                <div className={errors.indexOf("brand") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="select">
                    Manufacturer
                  </label>
                  <div className="col-sm-8">
                    <select
                      id="select"
                      name="select"
                      className={errors.indexOf("brand") !== -1 ? "form-control form-control-danger" : "form-control"}
                      size="1"
                      value={brand}
                      onChange={(brand) => onBrandChange(brand)}
                    >
                      <option value={-1}>Select brand</option>
                      {brands ? (
                        brands.map((brand) => {
                          return (
                            <option value={brand.id} key={brand.id}>
                              {brand.brand_name}
                            </option>
                          );
                        })
                      ) : (
                        <option value=" ">Loading...</option>
                      )}
                    </select>
                  </div>
                  {errors.indexOf("brand") !== -1 ? (
                    <em id="firstname-error" className="error form-control-feedback">
                      Please select Brand
                    </em>
                  ) : (
                    <em></em>
                  )}
                </div>
                {editingItem ? (
                  <div className="col-sm-6 form-group row">
                    <label className="col-sm-4 col-form-label" htmlFor="text-input">
                      Item
                    </label>
                    <div className="col-sm-8">
                      <input
                        disabled
                        type="text"
                        id="text-input"
                        name="text-input"
                        className="form-control"
                        value={itemOffers.length && itemOffers.filter((offer) => offer.vendor_id === selectedOffer)[0].display_name}
                      />
                    </div>
                  </div>
                ) : (
                  <div className={errors.indexOf("vendor") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                    <label className="col-sm-4 col-form-label" htmlFor="select">
                      Available vendors
                    </label>
                    <div className="col-sm-8">
                      <select
                        id="select"
                        name="select"
                        className={errors.indexOf("vendor") !== -1 ? "form-control form-control-danger" : "form-control"}
                        size="1"
                        value={selectedOffer}
                        onChange={(offer) => onOfferChange(offer)}
                      >
                        <option value={-1}>Best vendor offer</option>
                        {itemOffers ? (
                          itemOffers.map((itemOffer) => {
                            return (
                              <option value={itemOffer.vendor_id} key={itemOffer.vendor_id}>
                                {itemOffer.display_name}
                              </option>
                            );
                          })
                        ) : (
                          <option value=" ">Loading...</option>
                        )}
                      </select>
                    </div>
                    {errors.indexOf("offer") !== -1 ? (
                      <em id="firstname-error" className="error form-control-feedback">
                        Please select offer
                      </em>
                    ) : (
                      <em></em>
                    )}
                  </div>
                )}

                <div className={"col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">
                    Unit Price
                  </label>
                  <div className="col-sm-8 input-group">
                    <div className="input-group-addon">$</div>
                    <input
                      style={inputStyle}
                      type="number"
                      id="text-input"
                      name="text-input"
                      className={"form-control"}
                      placeholder="Unit price"
                      disabled
                      readOnly
                      value={price}
                    />
                  </div>
                </div>

                <div className={"col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">
                    Total price
                  </label>
                  <div className="col-sm-8 input-group">
                    <div className="input-group-addon">$</div>
                    <input
                      style={inputStyle}
                      type="number"
                      id="text-input"
                      name="text-input"
                      className={"form-control"}
                      placeholder="Total price"
                      disabled
                      readOnly
                      value={price * numberItems * quantity}
                    />
                  </div>
                </div>

                {hasGrade && (
                  <div className={errors.indexOf("grade") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                    <label className="col-sm-4 col-form-label" htmlFor="select">
                      Grade
                    </label>
                    <div className="col-sm-8">
                      <select
                        id="select"
                        name="select"
                        className={errors.indexOf("grade") !== -1 ? "form-control form-control-danger" : "form-control"}
                        size="1"
                        value={grade}
                        onChange={(grade) => onGradeChange(grade)}
                      >
                        <option value={-1}>Select grade</option>
                        {grades ? (
                          grades.map((grade) => {
                            return (
                              <option value={grade.id} key={grade.id}>
                                {grade.grade}
                              </option>
                            );
                          })
                        ) : (
                          <option value=" ">Loading...</option>
                        )}
                      </select>
                    </div>
                    {errors.indexOf("grade") !== -1 ? (
                      <em id="firstname-error" className="error form-control-feedback">
                        Please select Grade
                      </em>
                    ) : (
                      <em></em>
                    )}
                  </div>
                )}
              </form>

              {editingItem ? (
                <div className="add-repeat-btn">
                  <span className="btn btn-danger m-0" onClick={() => cancelEditItem()}>
                    Cancel
                  </span>
                  <div className="pl-h">
                    <span className="btn btn-primary m-0" onClick={() => updateItem()}>
                      Update
                    </span>
                  </div>
                </div>
              ) : (
                <div className="add-repeat-btn">
                  <span className="btn btn-primary m-0" onClick={() => addItem()}>
                    Add
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderInputBox;
